import { Box, CircularProgress, Stack, Typography } from '@mui/material'

export function FullScreenLoader({ label }: { label?: string }) {
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Stack spacing={2} alignItems="center">
        <CircularProgress size={36} thickness={4} />
        {label && (
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        )}
      </Stack>
    </Box>
  )
}
